const METRICOOL_HASH = process.env.REACT_APP_METRICOOL_HASH;

let scriptLoaded = false;

export function initMetricool() {
   if (!METRICOOL_HASH || scriptLoaded || typeof window === "undefined") return;

   const loadScript = (callback) => {
      const head = document.getElementsByTagName("head")[0];
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.src = "https://tracker.metricool.com/resources/be.js";
      script.onload = callback;
      head.appendChild(script);
   };

   loadScript(() => {
      if (window.beTracker) {
         window.beTracker.t({ hash: METRICOOL_HASH });
         scriptLoaded = true;
      }
   });
}

export function trackMetricoolPage() {
   if (!METRICOOL_HASH || !window.beTracker) return;
   window.beTracker.t({ hash: METRICOOL_HASH });
}
